module.exports = "<span class=\"price-display\">\n  <span ng-bind=\"$ctrl.price\"></span>\n</span>\n";